import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-comprobante',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './comprobante.component.html',
  styleUrls: ['./comprobante.component.scss']
})
export class ComprobanteComponent {
  @Input() userName: string = '';
  @Input() phoneNumber: string = '';
  @Input() seguroOption: string = '';
  @Input() diaPago: string = '';
} 